import React from 'react';
import {
  HeaderContainer,
  TitleContainer,
  Title,
  SubTitle,
  Nav,
  NavList,
  NavListItemMeLogo,
  MeLogo
} from '../app';
import profileImage from '../static/red-ai.jpg';

const Header = () => {
  return (
    <HeaderContainer>
      <TitleContainer>
        <Title>Brad Flood</Title>
        <SubTitle>Builder of Products,<br/>Platforms, and Teams</SubTitle>
      </TitleContainer>
      <Nav>
        <NavList>
          <NavListItemMeLogo>
            <MeLogo
              src={profileImage}
              alt="Profile image"
            />
          </NavListItemMeLogo>
        </NavList>
      </Nav>
    </HeaderContainer>
  );
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.js